import ListProjectsAsListbox from 'viewmodel/ListProjectsAsListboxViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';
import { registerDynImportEntry } from 'js/moduleLoader';

registerDynImportEntry('image/cmdSearch16.svg', () => import('image/cmdSearch16.svg'));
registerDynImportEntry('image/miscSortedDescending10.svg', () => import('image/miscSortedDescending10.svg'));

const COLLABORATIONSPACE_ID = 'collaborationspace-id';
const ROLE_FILTERS = 'role-filters';
const OWNERSHIP_FILTERS = 'ownership-filters';

export default class DesListProjectsAsListbox extends DesBaseCollabAcc {

    constructor() {
        super(ListProjectsAsListbox);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute(COLLABORATIONSPACE_ID);
    }

    get roleFilters() {
        return this.getAttribute(ROLE_FILTERS);
    }

    get ownershipFilters() {
        return this.getAttribute(OWNERSHIP_FILTERS);
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            roleFilters: this.roleFilters,
            ownershipFilters: this.ownershipFilters
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', COLLABORATIONSPACE_ID,
            ROLE_FILTERS, OWNERSHIP_FILTERS ];
    }
}
if (!window.customElements.get('des-list-projects-as-listbox')) {
    window.customElements.define(
        'des-list-projects-as-listbox',
        DesListProjectsAsListbox
    );
}
